import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'additional-information',
  templateUrl: 'additional-information.component.html',
  styleUrls: ['additional-information.component.scss'],
})
export class AdditionalInformationComponent extends BasePackagingComponent implements OnChanges {

  @Input() declare itemDetailsData: any;

  @Input() declare data: any;

  @Input() expiCodes: Array<any>;

  @Input() formGroup: UntypedFormGroup;

  additionalData: Array<any> = [];
  additionalFields: Array<string> = [
    'hazardous_materials.0.hazardous_material_code_qualifier',
    'hazardous_materials.0.hazardous_material_class_code',
    'hazardous_materials.0.hazardous_material_description',
    'hazardous_materials.0.whmis_code',
    'hazardous_materials.0.whmis_free_text',
    'hazardous_materials.0.packing_group_code',
    'hazardous_materials.0.regulations_exemption_code',
    'hazardous_materials.0.hazardous_placard_notation',
    'hazardous_materials.0.text_message'
  ];

  ngOnChanges() {
    this.prepareData();
  }

  prepareData() {
    this.additionalData = this.filterData(this.data, this.additionalFields);
  }

}
